






































import { branchDrafts, DraftCompanyParams } from '@/store/interfaces/drafts';
import drafts from '@/store/types/drafts';
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import InboundCard from './inboundCard.vue';
import teipTable from '@/components/partials/teip-table.vue';
import { tPropsToSearch, tTableColumns } from 'teip-components';
import removeBranchConfirm from '@/components/modals/actionConfirm.vue';
import teipModal from '@/components/Reusable/teipModal.vue';
import updateBranch from './forms/branch.vue';

@Component({
  components: {
    InboundCard,
    removeBranchConfirm,
    teipModal,
    teipTable,
    updateBranch,
  },
})
export default class Branchs extends Vue {
  propsToSearch: tPropsToSearch = ['name', 'address'];
  tableColumns: tTableColumns = [
    {
      prop: 'name',
      label: 'Nombre',
      minWidth: 250,
      sortable: true,
    },
    {
      prop: 'address',
      label: 'Dirección',
      minWidth: 250,
      sortable: true,
    },
    {
      prop: 'phone',
      label: 'Teléfono',
      minWidth: 250,
      sortable: true,
    },
    {
      prop: 'contact_name',
      label: 'Encargado',
      minWidth: 250,
      sortable: true,
    },
    {
      prop: 'contact_phone',
      label: 'Teléfono de encargado',
      minWidth: 250,
      sortable: true,
    }
  ];

  areYouSureToDeleteBranch = false;
  updateBranch = false;

  branch: branchDrafts = {
    id: '',
    name: '',
    address: '',
    phone: '',
    contact_phone: '',
    contact_name: '',
  };

  branchSelected(branch: branchDrafts): void {
    this.branch = branch;
  }

  updateInboundBranch(): void {
    this.updateBranch = true;
  }

  showAlertToDeleteBranch(): void {
    this.areYouSureToDeleteBranch = true;
  }

  deleteBranch(): void {
    this.draftCompany.branches = this.draftCompany.branches.filter(
      (branch) => branch.id !== this.branch.id
    );
    this.areYouSureToDeleteBranch = false;
  }

  @Getter(`drafts/${drafts.getters.GET_DRAFT_COMPANY}`)
  draftCompany!: DraftCompanyParams;
}
